import Enums from "../../../enums/enums";
import merchantHelper from "../../../helper/merchantHelper";
import i18n from "../../../locales/i18n";

const state = {
  loginstatus: Enums.LoadingStatusType.None,
  userModel: null,
  merchantList: null,
  merchantIdList: [],
  selectMerchant: null,
  selectMerchantLodingStatus: null,
  emi: "",
  otherUserList: [],
  otherUserListLoadingStatus: Enums.LoadingStatusType.None,
  merchantListLoadingStatus: Enums.LoadingStatusType.None,
  userListInMerchant: [],
  userListInMerchantLoadingStatus: Enums.LoadingStatusType.None,
  getUserInfoByUserIdLoadingStatus: Enums.LoadingStatusType.None,
  get2ndLoginLodingStatus: Enums.LoadingStatusType.None,
  set2ndLoginLodingStatus: Enums.LoadingStatusType.None,
  is2ndLogin: false,
  demoOrganize: null,
  refreshTokenExpirationLodingStatus: Enums.LoadingStatusType.None,
  getFavoriteMerchantList: [],
  getFavoriteMerchantListLoadingStatus: Enums.LoadingStatusType.None,
  updateFavoriteMerchantLoadingStatus: Enums.LoadingStatusType.None,
  deleteFavoriteMerchantLoadingStatus: Enums.LoadingStatusType.None,
  deleteMerchantLoadingStatus: Enums.LoadingStatusType.None,
  isCreatedMerchantNotSample: null,
  checkIsCreatedMerchantNotSampleLoadingStatus: Enums.LoadingStatusType.None,
  merchantModelByIdLoadingStatus: Enums.LoadingStatusType.None,
  merchantModelListForMap: new Map(),
};

const getters = {
  GetLoginstatus: (state) => {
    return state.loginstatus;
  },
  getUserModel: (state) => {
    return state.userModel;
  },
  GetDemoOrganize: (state) => {
    return state.demoOrganize;
  },
  GetMerchantList: (state) => {
    if (state.merchantList == null) {
      return [];
    } else {
      if (i18n.locale == Enums.LanguageType.Thai) {
        return state.merchantList.sort(merchantHelper.CompareMerchantNameTh);
      } else {
        return state.merchantList.sort(merchantHelper.CompareMerchantNameEn);
      }
    }
  },
  getEmi: (state) => {
    return state.emi;
  },
  GetOtherUserList: (state) => {
    return state.otherUserList;
  },
  GetOtherUserListLoadingStatus: (state) => {
    return state.otherUserListLoadingStatus;
  },
  GetMerchantListLoadingStatus: (state) => {
    return state.merchantListLoadingStatus;
  },
  GetUserListInMerchant: (state) => {
    return state.userListInMerchant;
  },
  GetUserListInMerchantLoadingStatus: (state) => {
    return state.userListInMerchantLoadingStatus;
  },
  GetUserInfoByUserIdLoadingStatus: (state) => {
    return state.getUserInfoByUserIdLoadingStatus;
  },
  GetMerchant: (state) => {
    return state.selectMerchant;
  },
  GetSelectMerchantLodingStatus: (state) => {
    return state.selectMerchantLodingStatus;
  },
  Get2ndLoginLodingStatus: (state) => {
    return state.get2ndLoginLodingStatus;
  },
  GetIs2ndLogin: (state) => {
    return state.is2ndLogin;
  },
  Set2ndLoginLodingStatus: (state) => {
    return state.set2ndLoginLodingStatus;
  },
  GetFavoriteMerchantList: (state) => {
    return state.getFavoriteMerchantList;
  },
  GetFavoriteMerchantListLoadingStatus: (state) => {
    return state.getFavoriteMerchantListLoadingStatus;
  },
  GetUpdateFavoriteMerchantLoadingStatus: (state) => {
    return state.updateFavoriteMerchantLoadingStatus;
  },
  GetDeleteFavoriteMerchantLoadingStatus: (state) => {
    return state.deleteFavoriteMerchantLoadingStatus;
  },
  GetDeleteMerchantLoadingStatus: (state) => {
    return state.deleteMerchantLoadingStatus;
  },
  GetIsCreatedMerchantNotSample: (state) => {
    return state.isCreatedMerchantNotSample;
  },
  GetCheckIsCreatedMerchantNotSampleLoadingStatus: (state) => {
    return state.checkIsCreatedMerchantNotSampleLoadingStatus;
  },
  GetMerchantModelListForMap: (state) => {
    return state.merchantModelListForMap;
  },
  GetMerchantModelByIdLoadingStatus: (state) => {
    return state.merchantModelByIdLoadingStatus;
  },
};
export { getters, state };
